import { Link } from 'react-router-dom'
import { useI18n } from '@runtime/core/i18n/i18n'
import logo from '@/routes/gateway/assets/united-square-logo.png'
import styles from './HomeFooter.module.scss'
export default function HomeFooter() {
  const { t } = useI18n()
  return (
    <footer className={styles.footer}>
      <div className={styles.brand}>
        <img src={logo} alt={t('common.brandName')} />
        <p>{t('home.welcome.footer')}</p>
      </div>
      <nav aria-label={t('home.footerLegal')}>
        <Link to="/privacy">{t('home.footerPrivacy')}</Link>
        <Link to="/privacy#mentions">{t('home.footerLegal')}</Link>
      </nav>
    </footer>
  )
}
